import React from 'react';

export function HeaderEaster() {
  return (
          
        <div className="easter-meadow-wrap">
          <svg viewBox="0 0 1440 50" className="meadow-svg" preserveAspectRatio="none">
            <defs>
              <linearGradient id="grassDark" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#15803d"/>
                <stop offset="100%" stopColor="#166534"/>
              </linearGradient>
              <linearGradient id="grassMid" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#22c55e"/>
                <stop offset="100%" stopColor="#16a34a"/>
              </linearGradient>
              <linearGradient id="grassLight" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#4ade80"/>
                <stop offset="100%" stopColor="#22c55e"/>
              </linearGradient>
            </defs>
            
            {/* Hintergrund-Gras - dunkelgrün */}
            <path d="M0 50 L0 25 Q60 15 120 25 Q180 10 240 22 Q300 15 360 25 Q420 8 480 20 Q540 12 600 25 Q660 10 720 22 Q780 15 840 25 Q900 8 960 20 Q1020 15 1080 25 Q1140 10 1200 22 Q1260 15 1320 25 Q1380 12 1440 20 L1440 50 Z" fill="url(#grassDark)"/>
            
            {/* Mittel-Gras - grün */}
            <path d="M0 50 L0 32 Q50 24 100 34 Q150 18 200 30 Q250 22 300 34 Q350 15 400 28 Q450 20 500 34 Q550 18 600 32 Q650 22 700 34 Q750 15 800 28 Q850 20 900 34 Q950 18 1000 32 Q1050 22 1100 34 Q1150 15 1200 28 Q1250 20 1300 34 Q1350 18 1400 30 L1440 32 L1440 50 Z" fill="url(#grassMid)"/>
            
            {/* Vordergrund-Gras - hellgrün */}
            <path d="M0 50 L0 42 Q40 36 80 44 Q120 32 160 42 Q200 36 240 44 Q280 30 320 42 Q360 34 400 44 Q440 32 480 42 Q520 36 560 44 Q600 30 640 42 Q680 34 720 44 Q760 32 800 42 Q840 36 880 44 Q920 30 960 42 Q1000 34 1040 44 Q1080 32 1120 42 Q1160 36 1200 44 Q1240 30 1280 42 Q1320 34 1360 44 Q1400 32 1440 40 L1440 50 Z" fill="url(#grassLight)"/>
            
            {/* Blumen in der Wiese */}
            {/* Gelbe Blumen */}
            <circle cx="100" cy="38" r="4" fill="#fbbf24"/>
            <circle cx="100" cy="38" r="2" fill="#f59e0b"/>
            <circle cx="320" cy="36" r="3.5" fill="#fbbf24"/>
            <circle cx="320" cy="36" r="1.8" fill="#f59e0b"/>
            <circle cx="580" cy="40" r="4" fill="#fbbf24"/>
            <circle cx="580" cy="40" r="2" fill="#f59e0b"/>
            <circle cx="850" cy="37" r="3.5" fill="#fbbf24"/>
            <circle cx="850" cy="37" r="1.8" fill="#f59e0b"/>
            <circle cx="1100" cy="39" r="4" fill="#fbbf24"/>
            <circle cx="1100" cy="39" r="2" fill="#f59e0b"/>
            <circle cx="1320" cy="36" r="3.5" fill="#fbbf24"/>
            
            {/* Rosa/Pink Blumen */}
            <circle cx="180" cy="40" r="3.5" fill="#ec4899"/>
            <circle cx="180" cy="40" r="1.8" fill="#fbbf24"/>
            <circle cx="450" cy="37" r="4" fill="#f472b6"/>
            <circle cx="450" cy="37" r="2" fill="#fbbf24"/>
            <circle cx="720" cy="39" r="3.5" fill="#ec4899"/>
            <circle cx="720" cy="39" r="1.8" fill="#fbbf24"/>
            <circle cx="980" cy="41" r="4" fill="#f472b6"/>
            <circle cx="980" cy="41" r="2" fill="#fbbf24"/>
            <circle cx="1220" cy="38" r="3.5" fill="#ec4899"/>
            
            {/* Weiße Gänseblümchen */}
            <circle cx="250" cy="42" r="3.5" fill="white"/>
            <circle cx="250" cy="42" r="1.8" fill="#fbbf24"/>
            <circle cx="520" cy="39" r="3" fill="white"/>
            <circle cx="520" cy="39" r="1.5" fill="#fbbf24"/>
            <circle cx="780" cy="41" r="3.5" fill="white"/>
            <circle cx="780" cy="41" r="1.8" fill="#fbbf24"/>
            <circle cx="1050" cy="38" r="3" fill="white"/>
            <circle cx="1050" cy="38" r="1.5" fill="#fbbf24"/>
            <circle cx="1380" cy="40" r="3.5" fill="white"/>
            <circle cx="1380" cy="40" r="1.8" fill="#fbbf24"/>
          </svg>
          
          {/* Osterhase in der Wiese */}
          <div className="easter-bunny-container">
            <svg viewBox="0 0 80 100" className="easter-bunny-svg">
              <defs>
                <linearGradient id="bunnyFur" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#e5e7eb"/>
                  <stop offset="100%" stopColor="#d1d5db"/>
                </linearGradient>
                <linearGradient id="bunnyInnerEar" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#fda4af"/>
                  <stop offset="100%" stopColor="#fb7185"/>
                </linearGradient>
                <linearGradient id="phoneScreen" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#60a5fa"/>
                  <stop offset="100%" stopColor="#3b82f6"/>
                </linearGradient>
                <filter id="bunnyGlow" x="-20%" y="-20%" width="140%" height="140%">
                  <feGaussianBlur stdDeviation="1" result="glow"/>
                  <feMerge>
                    <feMergeNode in="glow"/>
                    <feMergeNode in="SourceGraphic"/>
                  </feMerge>
                </filter>
                <filter id="phoneShadow" x="-50%" y="-50%" width="200%" height="200%">
                  <feDropShadow dx="0" dy="1" stdDeviation="1" floodColor="#000" floodOpacity="0.3"/>
                </filter>
              </defs>
              {/* Ohren */}
              <ellipse cx="28" cy="18" rx="8" ry="22" fill="url(#bunnyFur)" filter="url(#bunnyGlow)"/>
              <ellipse cx="28" cy="20" rx="4" ry="14" fill="url(#bunnyInnerEar)"/>
              <ellipse cx="52" cy="18" rx="8" ry="22" fill="url(#bunnyFur)" filter="url(#bunnyGlow)"/>
              <ellipse cx="52" cy="20" rx="4" ry="14" fill="url(#bunnyInnerEar)"/>
              {/* Körper */}
              <ellipse cx="40" cy="72" rx="18" ry="16" fill="url(#bunnyFur)" filter="url(#bunnyGlow)"/>
              
              {/* O2 Logo auf dem Körper */}
              <g transform="translate(28, 64)">
                <text x="0" y="8" fontSize="9" fontWeight="bold" fill="#0050aa" fontFamily="Arial, sans-serif">O</text>
                <text x="8" y="11" fontSize="5" fontWeight="bold" fill="#0050aa" fontFamily="Arial, sans-serif">2</text>
              </g>
              
              {/* Kopf */}
              <ellipse cx="40" cy="48" rx="16" ry="14" fill="url(#bunnyFur)" filter="url(#bunnyGlow)"/>
              {/* Wangen */}
              <ellipse cx="27" cy="52" rx="5" ry="3" fill="#fda4af" opacity="0.5"/>
              <ellipse cx="53" cy="52" rx="5" ry="3" fill="#fda4af" opacity="0.5"/>
              {/* Augen */}
              <ellipse cx="33" cy="46" rx="4" ry="5" fill="white"/>
              <ellipse cx="47" cy="46" rx="4" ry="5" fill="white"/>
              <circle cx="34" cy="47" r="2.5" fill="#1f2937"/>
              <circle cx="48" cy="47" r="2.5" fill="#1f2937"/>
              <circle cx="35" cy="46" r="1" fill="white"/>
              <circle cx="49" cy="46" r="1" fill="white"/>
              {/* Nase */}
              <ellipse cx="40" cy="53" rx="3" ry="2.5" fill="#fb7185"/>
              {/* Mund */}
              <path d="M37 56 Q40 59 43 56" stroke="#9ca3af" strokeWidth="1" fill="none"/>
              {/* Schnurrhaare */}
              <line x1="25" y1="52" x2="15" y2="50" stroke="#9ca3af" strokeWidth="0.8"/>
              <line x1="25" y1="54" x2="15" y2="55" stroke="#9ca3af" strokeWidth="0.8"/>
              <line x1="55" y1="52" x2="65" y2="50" stroke="#9ca3af" strokeWidth="0.8"/>
              <line x1="55" y1="54" x2="65" y2="55" stroke="#9ca3af" strokeWidth="0.8"/>
              
              {/* Linker Arm mit Handy */}
              <g transform="translate(8, 58) rotate(-15)">
                {/* Arm/Pfote */}
                <ellipse cx="8" cy="12" rx="5" ry="8" fill="url(#bunnyFur)"/>
                {/* Handy */}
                <g filter="url(#phoneShadow)">
                  <rect x="2" y="2" width="12" height="20" rx="2" fill="#1f2937"/>
                  <rect x="3" y="4" width="10" height="15" rx="1" fill="url(#phoneScreen)"/>
                  {/* O2 Logo auf Handy-Display */}
                  <text x="4" y="13" fontSize="6" fontWeight="bold" fill="white" fontFamily="Arial, sans-serif">O</text>
                  <text x="9" y="14.5" fontSize="3.5" fontWeight="bold" fill="white" fontFamily="Arial, sans-serif">2</text>
                  {/* Handy-Kamera */}
                  <circle cx="8" cy="21" r="0.8" fill="#4b5563"/>
                </g>
              </g>
              
              {/* Rechter Arm */}
              <ellipse cx="58" cy="68" rx="5" ry="7" fill="url(#bunnyFur)" transform="rotate(15, 58, 68)"/>
              
              {/* Pfoten */}
              <ellipse cx="28" cy="88" rx="6" ry="4" fill="url(#bunnyFur)"/>
              <ellipse cx="52" cy="88" rx="6" ry="4" fill="url(#bunnyFur)"/>
              {/* Schwänzchen */}
              <circle cx="58" cy="72" r="5" fill="white" filter="url(#bunnyGlow)"/>
            </svg>
          </div>
          
          {/* Ostereier in der Wiese */}
          <svg className="easter-egg egg-1" viewBox="0 0 30 40">
            <ellipse cx="15" cy="22" rx="12" ry="16" fill="#ec4899"/>
            <path d="M5 16 Q15 10 25 16" stroke="#fbbf24" strokeWidth="2.5" fill="none"/>
            <path d="M5 22 Q15 28 25 22" stroke="#22d3ee" strokeWidth="2.5" fill="none"/>
            <circle cx="10" cy="26" r="2" fill="#fbbf24"/>
            <circle cx="20" cy="18" r="2" fill="#22d3ee"/>
          </svg>
          <svg className="easter-egg egg-2" viewBox="0 0 30 40">
            <ellipse cx="15" cy="22" rx="11" ry="15" fill="#22d3ee"/>
            <path d="M6 14 L24 14" stroke="white" strokeWidth="2" opacity="0.7"/>
            <path d="M6 22 L24 22" stroke="white" strokeWidth="2" opacity="0.7"/>
            <circle cx="11" cy="18" r="2.5" fill="#fbbf24"/>
            <circle cx="19" cy="26" r="2.5" fill="#ec4899"/>
          </svg>
          <svg className="easter-egg egg-3" viewBox="0 0 30 40">
            <ellipse cx="15" cy="22" rx="10" ry="14" fill="#a855f7"/>
            <path d="M7 18 Q15 12 23 18" stroke="#fbbf24" strokeWidth="2" fill="none"/>
            <path d="M7 26 Q15 32 23 26" stroke="#22c55e" strokeWidth="2" fill="none"/>
            <circle cx="15" cy="22" r="3" fill="#fbbf24"/>
          </svg>
        </div>
  );
}